import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom"
import { LocationProvider } from './context/LocationContext';
import { AuthProvider } from './context/AuthContext';
import { SidebarProvider } from './context/SidebarContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from './App';
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AuthProvider >
        <LocationProvider>
          <SidebarProvider>
            <App />
          </SidebarProvider>
        </LocationProvider>
      </AuthProvider>
    </BrowserRouter>
  </QueryClientProvider>
);